import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { MatSnackBar } from '@angular/material';
import { isEmptyOrNull } from './utils';

@Injectable({
  providedIn: 'root'
})
export class WithdrawalRequestService {
  protected defaultController = `https://api.${environment.baseUrl}/api/`;
  protected slug = 'withdrawal';
  constructor(public http: HttpClient, private snackBar: MatSnackBar) {
  }

  public getAllWithdrawals(): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}`);
  }

  public createWithdrawal(payload: any): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err2', {
          duration: 5000,
        });
      }));
  }

  public deleteWithdrawal(id: string): Observable<any> {
    return this.http.delete(`${this.defaultController}${this.slug}/${id}`).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err1', {
          duration: 5000,
        });
      }));
  }
}
